import type { Session } from '@supabase/supabase-js';
import { z } from 'zod';

import { apiFetch } from '@/lib/api';

// Client contract for GET /api/v1/admin/queues (pg-boss health). Zod-parsed on
// arrival so drift from the API surfaces loudly.

export const QueueHealthSchema = z.object({
  queues: z.array(
    z.object({
      name: z.string(),
      created: z.number(),
      retry: z.number(),
      active: z.number(),
      completed: z.number(),
      failed: z.number(),
      oldestPendingAgeSeconds: z.number().nullable(),
    }),
  ),
  failedRecent: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      failedAt: z.string().nullable(),
      error: z.string().nullable(),
      retryable: z.boolean(),
    }),
  ),
  schedules: z.array(
    z.object({
      name: z.string(),
      cron: z.string(),
      timezone: z.string().nullable(),
      lastRunAt: z.string().nullable(),
    }),
  ),
});

export type QueueHealth = z.infer<typeof QueueHealthSchema>;

export const fetchQueueHealth = (session: Session, signal?: AbortSignal): Promise<QueueHealth> =>
  apiFetch('/api/v1/admin/queues', {
    session,
    schema: QueueHealthSchema,
    ...(signal ? { signal } : {}),
  });

const RetryResponseSchema = z.object({ queue: z.string() });

export const retryJob = (session: Session, jobId: string): Promise<{ queue: string }> =>
  apiFetch('/api/v1/admin/queues/retry', {
    session,
    method: 'POST',
    body: { jobId },
    schema: RetryResponseSchema,
  });
